export default __webpack_public_path__ + "static/media/battle_button.4d9f8617.png";